import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';

import withComponentName from '../../../../decorators/withComponentName';
import SwitchButton from '../../../MainTrending/TrendingFilters/TrendingPersonalisationFilter/SwitchButton';
import ChangeViewButton from '../../../MainTrending/TrendingFilters/TrendingPersonalisationFilter/ChangeViewButton';
import ChangeLayoutButton from '../../../MainTrending/TrendingFilters/TrendingPersonalisationFilter/ChangeLayoutButton';

import { SUMMARISATION } from '../../../../data/features';

import Styles from '../../story-filters-styles.module.scss';
import PlayVideoComponent from '../../../PlayVideoComponent';

const cx = classNames.bind(Styles);

const DropdownFilters = (props) => {
  const {
    expandStories,
    userNewsfeedViewImages,
    userNewsfeedViewDescription,
    storyPreview,
    summarisationEnabled,
    userNewsfeedView,
    userNewsfeedViewCompact,
    onExpandStories,
    onUserNewsfeedViewImages,
    onUserNewsfeedViewDescription,
    onStoryPreview,
    onShowSummarisation,
    onUserNewsfeedView,
    groupSimilars,
    onGroupSimilars,
    showSimilars,
    onShowSimilars,
    rbi,
    onSimplifiedViewTabsClick,
    isSimpleLayout,
    hasBigScreenDesign,
    onTogglePremiumLabels,
    isPremiumLabelsEnabled,
    playVideoButton,
    bookmarksPage,
  } = props;

  const switchImagesButton = useRef(null);
  const switchDescriptionButton = useRef(null);
  const switchStoryPreviewButton = useRef(null);
  const switchExpandStoriesButton = useRef(null);
  const switchGroupSimilarsButton = useRef(null);
  const switchShowSimilarsButton = useRef(null);
  const switchSummarisationButton = useRef(null);
  const switchUserNewsfeedView = useRef(null);
  const switchPremiumLabelsButton = useRef(null);
  const [userSwitchView, setUserSwitchView] = useState();

  const hasSummarisationAccess = useSelector(({ subscriptions }) => (
    subscriptions.permissionsInitialized
    && subscriptions.permissions.features.includes(SUMMARISATION)
  ));

  useEffect(() => {
    switchImagesButton.current.setState({ checkStatus: userNewsfeedViewImages });
  }, [userNewsfeedViewImages]);
  useEffect(() => {
    switchDescriptionButton.current.setState({ checkStatus: userNewsfeedViewDescription });
  }, [userNewsfeedViewDescription]);
  useEffect(() => {
    switchStoryPreviewButton.current.setState({ checkStatus: storyPreview });
  }, [storyPreview]);
  useEffect(() => {
    switchExpandStoriesButton.current.setState({ checkStatus: expandStories });
  }, [expandStories]);
  useEffect(() => {
    switchGroupSimilarsButton.current.setState({ checkStatus: groupSimilars });
  }, [groupSimilars]);
  useEffect(() => {
    switchShowSimilarsButton.current.setState({ checkStatus: showSimilars });
  }, [showSimilars]);
  useEffect(() => {
    if (hasSummarisationAccess) {
      switchSummarisationButton.current.setState({ checkStatus: summarisationEnabled });
    }
  }, [summarisationEnabled, hasSummarisationAccess]);
  useEffect(() => {
    const value = userNewsfeedViewCompact ? 'compact' : userNewsfeedView;
    setUserSwitchView(value);
    switchUserNewsfeedView.current.setState({ checkStatus: value });
  }, [userNewsfeedView, userNewsfeedViewCompact]);

  // useEffect(() => {
  //   switchPremiumLabelsButton.current.setState({ checkStatus: isPremiumLabelsEnabled });
  // }, [isPremiumLabelsEnabled]);

  return (
    <div className={cx('other-filters')}>
      <div className={cx('other-filters__view--layout')}>
        <span className={cx('filter__item--heading')}>
          Layout View:
          {playVideoButton && (
          <PlayVideoComponent
            videoLink="https://cityfalcon.wistia.com/medias/ld0y8ltub3"
            videoLinkMobile="https://cityfalcon.wistia.com/medias/ktxo5yh7gp"
            additionalStyles={cx('other_filters_play_button')}
            tooltipAdditionalContentStyle={cx('other_filters_play_button_tooltip')}
          />
          )}
        </span>
        <div className={cx('other-filters__view')}>
          {onSimplifiedViewTabsClick
            && (
              <div className={cx('other-filters__view--row', 'view_row')}>
                <ChangeLayoutButton
                  id="simple"
                  title="Simple"
                  status={isSimpleLayout}
                  onSimplifiedViewTabsClick={onSimplifiedViewTabsClick}
                  name="simplifiedLayout"
                  viewClass="simple-layout"
                  bookmarksPage={bookmarksPage}
                />
                <ChangeLayoutButton
                  id="advanced"
                  title="Advanced"
                  status={isSimpleLayout}
                  onSimplifiedViewTabsClick={onSimplifiedViewTabsClick}
                  name="simplifiedLayout"
                  viewClass="advanced-layout"
                  bookmarksPage={bookmarksPage}
                />
              </div>
            )}
          <div className={cx('other-filters__view--row', 'view_row')}>
            <ChangeViewButton
              id="rows__switch"
              ref={switchUserNewsfeedView}
              status={userSwitchView}
              rbi={rbi}
              title="Rows"
              onChange={onUserNewsfeedView}
              name="userNewsfeedView"
              viewClass="list-view"
              hasBigScreenDesign={hasBigScreenDesign}
            />
            <ChangeViewButton
              id="compact__switch"
              ref={switchUserNewsfeedView}
              status={userSwitchView}
              rbi={rbi}
              title="Compact"
              onChange={onUserNewsfeedView}
              name="userNewsfeedView"
              viewClass="compact-view"
              hasBigScreenDesign={hasBigScreenDesign}
              disabled={bookmarksPage}
            />
            <ChangeViewButton
              id="tiles__switch"
              ref={switchUserNewsfeedView}
              status={userSwitchView}
              rbi={rbi}
              title="Tiles"
              onChange={onUserNewsfeedView}
              name="userNewsfeedView"
              viewClass="tiles-view"
              hasBigScreenDesign={hasBigScreenDesign}
              disabled={bookmarksPage}
            />
          </div>
        </div>
      </div>
      <div className={cx('other-filters__misc--container')}>
        <span className={cx('filter_heading')}>Show:</span>
        {hasSummarisationAccess && (
          <div>
            <SwitchButton
              id="summarisation__switch"
              ref={switchSummarisationButton}
              status={summarisationEnabled}
              rbi={rbi}
              onChange={onShowSummarisation}
              hasBigScreenDesign={hasBigScreenDesign}
              title={(
                <div className={cx('summarisation-title')}>
                  Key Headlines
                  <PlayVideoComponent
                    videoLink="https://cityfalcon.wistia.com/medias/k5usrkqi3k"
                    videoLinkMobile="https://cityfalcon.wistia.com/medias/2eznzz1ra6"
                    additionalStyles={cx('other_filters_play_button')}
                    tooltipAdditionalContentStyle={cx('other_filters_play_button_tooltip')}
                  />
                </div>
              )}
            />
          </div>
        )}
        <div>
          <SwitchButton
            id="images__switch"
            ref={switchImagesButton}
            status={userNewsfeedViewImages}
            rbi={rbi}
            onChange={onUserNewsfeedViewImages}
            title="Images"
            hasBigScreenDesign={hasBigScreenDesign}
            disabled={userNewsfeedViewCompact}
          />
        </div>
        <div>
          <SwitchButton
            id="Description__switch"
            ref={switchDescriptionButton}
            status={userNewsfeedViewDescription}
            rbi={rbi}
            onChange={onUserNewsfeedViewDescription}
            title="Description"
            hasBigScreenDesign={hasBigScreenDesign}
            disabled={userNewsfeedViewCompact}
          />
        </div>
        <div style={{ display: 'none' }}>
          <SwitchButton
            id="storyPreview__switch"
            ref={switchStoryPreviewButton}
            status={storyPreview}
            rbi={rbi}
            onChange={onStoryPreview}
            title="Story Preview"
            hasBigScreenDesign={hasBigScreenDesign}
            disabled={userNewsfeedViewCompact}
          />
        </div>
        <div>
          <SwitchButton
            id={cx('expand__switch')}
            ref={switchExpandStoriesButton}
            status={expandStories}
            rbi={rbi}
            onChange={onExpandStories}
            title="Full Details"
            disabled={userNewsfeedView === 'tiles' || userNewsfeedViewCompact}
            hasBigScreenDesign={hasBigScreenDesign}
          />
        </div>
        {/* TODO: WEB-8187 Premium Publications will add again in future */}
        {/* <div>
          <SwitchButton
            id={cx('premium-labels__switch')}
            ref={switchPremiumLabelsButton}
            status={isPremiumLabelsEnabled}
            rbi={rbi}
            onChange={onTogglePremiumLabels}
            title="Labels for Premium features and content"
            hasBigScreenDesign={hasBigScreenDesign}
          />
        </div> */}
        <hr className={cx('group-similar-stories')} />
        <div>
          <SwitchButton
            id={cx('group__switch')}
            ref={switchGroupSimilarsButton}
            status={groupSimilars}
            rbi={rbi}
            onChange={onGroupSimilars}
            title="Group Similar Stories"
            hasBigScreenDesign={hasBigScreenDesign}
          />
        </div>
        <div className={cx('show-similar-title')}>
          <SwitchButton
            id={cx('similar__switch')}
            ref={switchShowSimilarsButton}
            status={showSimilars}
            rbi={rbi}
            onChange={onShowSimilars}
            title="Show Similar Stories in the Feed"
            disabled={!groupSimilars}
            hasBigScreenDesign={hasBigScreenDesign}
          />
        </div>
      </div>
    </div>
  );
};

export default withComponentName(DropdownFilters);
